/* Detailing1: technische Daten der Produktseite je Variante umschalten.
   Die Werte aller Varianten stehen als JSON in der Seite (script.js-d1-spec-data),
   getauscht wird beim Theme-Ereignis on:variant:change — kein Nachladen.
   Kennt das JSON eine Varianten-ID nicht (Liquid liefert hoechstens 250 Varianten),
   werden die variantenabhaengigen Zeilen ausgeblendet statt falsche Werte stehen zu lassen. */
(function () {
  function init() {
    var wrap = document.querySelector('[data-d1-spec]');
    if (!wrap || wrap.dataset.d1SpecReady === '1') return;
    var holder = document.querySelector('.js-d1-spec-data');
    if (!holder) return;
    var daten;
    try {
      daten = JSON.parse(holder.textContent || '{}');
    } catch (e) {
      return;
    }
    wrap.dataset.d1SpecReady = '1';

    function setze(id) {
      var satz = daten[String(id)];
      wrap.querySelectorAll('[data-d1-spec-row]').forEach(function (row) {
        var feld = row.querySelector('[data-d1-spec-value]');
        var wert = satz ? satz[row.dataset.d1SpecRow] || '' : '';
        if (feld) feld.textContent = wert;
        row.hidden = !wert;
      });
      var dimensionsNote = wrap.querySelector('[data-d1-dimensions-note]');
      if (dimensionsNote) {
        dimensionsNote.hidden = !(satz && (satz.width || satz.length || satz.height));
      }
      wrap.querySelectorAll('.d1-spec__group--variante, .d1-spec__group--dimensions').forEach(function (gruppe) {
        gruppe.hidden = gruppe.querySelectorAll('[data-d1-spec-row]:not([hidden])').length === 0;
      });
    }

    document.addEventListener('on:variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      setze(v && v.id ? v.id : null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
